import React, { useContext } from 'react';
import { GenericArea, SeatingViewerContext, isPlaceOccupied, COLORS } from '@wix/seating-common-components';
import s from './area.scss';
export const Area = ({ definition, definition: { categoryId, places } }) => {
    const { onPlaceClick, placesStock, onPlaceMouseEnter, onPlaceMouseLeave, currentlyClickedPlaceId, mobile } = useContext(SeatingViewerContext);
    const place = places[0];
    const placeId = place?.id;
    const placeClicked = currentlyClickedPlaceId && currentlyClickedPlaceId === placeId;
    const occupied = isPlaceOccupied(place, placesStock);
    const handlePlaceClick = () => {
        if (occupied) {
            return;
        }
        onPlaceClick?.({ place, categoryId, definition });
    };
    const getDefinition = () => {
        if (occupied) {
            return { ...definition, shapeColor: COLORS.TRANSPARENT };
        }
        if (placeClicked) {
            return { ...definition, shapeColor: COLORS.WHITE };
        }
        return definition;
    };
    return (React.createElement(GenericArea, { className: `${occupied ? s.occupiedArea : s.area} ${mobile ? s.mobile : ''}`, labelClassName: s.label, definition: getDefinition(), dataHook: place?.id, cursor: occupied ? 'default' : 'pointer', onClick: handlePlaceClick, onMouseEnter: onPlaceMouseEnter ? event => onPlaceMouseEnter({ event, place, categoryId }) : null, onMouseLeave: onPlaceMouseLeave ? event => onPlaceMouseLeave({ event, place, categoryId }) : null }));
};
//# sourceMappingURL=area.js.map